<template>
  <v-container class="px-10" fluid>
    <v-row justify="space-between">
      <v-col cols="3" class="pl-0 pr-2 pt-0">
        <extracoes-bdgd-estrutura-banco :bdgdId="bdgdId" @update-values="estruturaUpdate" />
      </v-col>

      <v-col cols="9" class="px-0 py-0">
        <extracoes-bdgd-executar-query
          ref="executarQuery"
          :selectedTable="selectedTable"
          :bdgdId="bdgdId"
          :tables="tables"
          :active="active"
          @update-values="queryUpdate"
        />

        <base-card class="mt-1 px-5 py-3">
          <v-tabs v-model="tabs" fixed-tabs>
            <v-tabs-slider></v-tabs-slider>
            <v-tab :disabled="!selectedTable" href="#tab-query-data" class="primary--text">
              <v-icon left>mdi-database</v-icon>
              Dados Query
            </v-tab>
            <v-tab href="#tab-history" class="primary--text">
              <v-icon left>mdi-view-list</v-icon>
              Extrações Processadas
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tabs">
            <v-tab-item value="tab-query-data">
              <first-tab-content-bdgd
                :headers="headers"
                :queryData="queryData"
                :errorSql="errorSql"
                :loadingExecQuery="loadingExecQuery"
                @refresh="$refs.executarQuery.getQueryData()"
              />
            </v-tab-item>
            <v-tab-item value="tab-history">
              <second-tab-content-bdgd ref="historyTab" :bdgdId="bdgdId" />
            </v-tab-item>
          </v-tabs-items>
        </base-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'ExtracoesBdgdIndex',

    components: {
      ExtracoesBdgdEstruturaBanco: () => import('@/components/dados/extracoes-bdgd/ExtracoesBdgdEstruturaBanco.vue'),
      ExtracoesBdgdExecutarQuery: () => import('@/components/dados/extracoes-bdgd/ExtracoesBdgdExecutarQuery.vue'),
      FirstTabContentBdgd: () => import('@/components/dados/extracoes-bdgd/tabs/FirstTabContentBdgd.vue'),
      SecondTabContentBdgd: () => import('@/components/dados/extracoes-bdgd/tabs/SecondTabContentBdgd.vue')
    },

    data: () => ({
      active: [],
      tables: [],
      headers: [],
      queryData: [],
      tabs: null,
      errorSql: null,
      selectedTable: null,
      loadingExecQuery: false
    }),

    computed: {
      bdgdId() {
        return this.$route.params.id;
      }
    },

    methods: {
      estruturaUpdate({ selectedTable, tables, active }) {
        this.selectedTable = selectedTable;
        this.tables = tables;
        this.active = active;
      },
      queryUpdate({ headers, queryData, loading, error, recharge }) {
        this.headers = headers;
        this.queryData = queryData;
        this.loadingExecQuery = loading;
        this.errorSql = error;

        if (recharge && this.$refs.historyTab) {
          this.$refs.historyTab.getAllExtracoes();
        }
      }
    }
  };
</script>
